module.exports = __webpack_public_path__ + "static/media/resume-classification.10d17dc7.svg";